var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import channel from '../../socket';
import { showFlash } from '../flash_show';
const SOCKET_EVENTS = Object.freeze({
    POST_STATS_REFRESHED: 'post_stats_refreshed'
});
const RELOAD_LINK_CLASS = 'js-reload_post_list';
const postListSelector = (publicationId) => `.js-backend_publication_posts_${publicationId}`;
const webStatsSelector = (publicationId) => `.js-backend_publication_posts_web_stats_${publicationId}`;
const flashHTML = (publicationId, message, linkText) => {
    const link = document.createElement('a');
    link.href = '#';
    link.className = RELOAD_LINK_CLASS;
    link.dataset.publicationId = publicationId;
    link.textContent = linkText;
    const flash = document.createElement('span');
    flash.append(`${message} `, link);
    return flash.innerHTML;
};
const onPostStatsRefreshed = ({ publicationId }) => {
    const postList = document.querySelector(postListSelector(publicationId));
    const message = postList === null || postList === void 0 ? void 0 : postList.dataset.postStatsRefreshedMessage;
    const linkText = postList === null || postList === void 0 ? void 0 : postList.dataset.postStatsReloadLinkText;
    if (message && linkText) {
        showFlash('info', flashHTML(publicationId, message, linkText));
    }
};
const reloadPostList = (publicationId) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const postList = document.querySelector(postListSelector(publicationId));
    if (postList) {
        const openSideviewId = (_a = postList
            .querySelector('.js-open_sideview[aria-expanded="true"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('aria-controls');
        // One request for the table and the line under the intro, from the table's own source, which carries sort, filters,
        // search and page; without the URL Unpoly would take the source of the line, the first match of the selector list.
        yield window.up.reload(`${postListSelector(publicationId)}, ${webStatsSelector(publicationId)}`, {
            url: window.up.fragment.source(postList),
            scroll: false
        });
        // The reloaded table renders every sideview closed; reopen the one that was open through its button.
        if (openSideviewId) {
            (_b = document.querySelector(`.js-open_sideview[aria-controls="${openSideviewId}"]`)) === null || _b === void 0 ? void 0 : _b.click();
        }
    }
});
const onReloadLinkClick = (event) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const link = event.target instanceof Element ? event.target.closest(`.${RELOAD_LINK_CLASS}`) : null;
    if (link === null || link === void 0 ? void 0 : link.dataset.publicationId) {
        event.preventDefault();
        event.stopPropagation();
        yield reloadPostList(link.dataset.publicationId);
        (_a = link.closest('flash-message')) === null || _a === void 0 ? void 0 : _a.remove();
    }
});
// Stops the click in the capture phase, because sideview.js closes an open sideview on any click outside it.
document.addEventListener('click', onReloadLinkClick, { capture: true });
if (channel) {
    const channelHandler = channel.on(SOCKET_EVENTS.POST_STATS_REFRESHED, onPostStatsRefreshed);
    window.addEventListener('beforeunload', () => {
        channel === null || channel === void 0 ? void 0 : channel.off(SOCKET_EVENTS.POST_STATS_REFRESHED, channelHandler);
    });
}
